import { DialogDescription, DialogHeader, DialogTitle } from "design-system/atoms/Dialog"
import { Card, CardDescription, CardHeader, CardTitle } from "design-system/molecules/Card"
import { useTranslation } from "react-i18next"

type Props = {
  reach: number
  audience: number
  optedOutCount?: number
  isEstimate?: boolean
}

export function LaunchCampaignReachContent({ reach, audience, optedOutCount, isEstimate }: Props) {
  const { t } = useTranslation()

  return (
    <DialogHeader className="flex flex-col gap-6">
      <DialogTitle>{t("campaigns.launchManual.title")}</DialogTitle>
      <DialogDescription className="flex flex-col gap-1 text-base">
        <span>{t("campaigns.launchManual.description")}</span>
      </DialogDescription>
      <DialogDescription>
        <div className="flex flex-row justify-between gap-0 w-full">
          <Card className="w-full">
            <CardHeader className="flex flex-col gap-1 text-center items-center">
              <CardDescription>
                {isEstimate
                  ? t("campaigns.launchManual.estimatedReach")
                  : t("campaigns.launchManual.reach")}
              </CardDescription>
              <CardTitle className="font-normal flex flex-row items-end gap-2">
                <span className="text-3xl font-medium font-mono">
                  {isEstimate ? "~" : ""}
                  {t("campaigns.launchManual.amount", { count: reach })}
                </span>
                <span className="text-sm text-muted-foreground mb-1">
                  {t("campaigns.launchManual.audienceCount", { count: audience })}
                </span>
              </CardTitle>
              {Boolean(optedOutCount) && (
                <span className="text-xs text-muted-foreground">
                  {t("campaigns.launchAudience.optedOut", { count: optedOutCount })}
                </span>
              )}
            </CardHeader>
          </Card>
        </div>
      </DialogDescription>
    </DialogHeader>
  )
}
